module.exports = __webpack_public_path__ + "img/new_friend_cover.9d358d7a.png";